import {
  Box,
  VStack,
  HStack,
  Text,
  Button,
  Stack,
  Icon,
} from "@chakra-ui/react";
import { StaticImage } from "gatsby-plugin-image";
import React, { useState } from "react";
import {
  ArrowRightLine,
  ArrowRightSLine,
  ArrowRightSLineGrey,
} from "../../customIcons";

interface ApplySectionProps {
  content: Array<{
    title: string;
    description: string;
    button?: string;
  }>;
}

const ApplySection: React.FC<ApplySectionProps> = ({ content }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const { description, button } = content[selectedIndex];

  return (
    <Stack
      direction={{ base: "column", md: "row" }}
      align="flex-start"
      w="100%"
      maxW="1280px"
      mx="auto"
      gap={10}
      py={{ base: 10, md: 20 }}
      px={{ base: 4, "2xl": 0 }}
    >
      <VStack gap={0} align="flex-start" w={{ base: "100%", sm: "432px" }}>
        {content.map((item, index) => (
          <HStack
            px={5}
            py={8}
            borderBottom={
              index !== content.length - 1 ? "1px solid #DADEDC" : "none"
            }
            gap={0}
            justify="space-between"
            w="100%"
            key={index}
            cursor="pointer"
            onClick={() => setSelectedIndex(index)}
          >
            <Text
              as="h3"
              fontSize="24px"
              lineHeight="100%"
              color={selectedIndex === index ? "#1B1E1E" : "#6A7471"}
              className={
                selectedIndex === index ? "grotesk-medium" : "grotesk-regular"
              }
            >
              {item.title}
            </Text>
            <Icon
              w="24px"
              h="24px"
              as={
                selectedIndex === index ? ArrowRightSLine : ArrowRightSLineGrey
              }
            />
          </HStack>
        ))}
      </VStack>

      <VStack align="flex-start" w="100%" flex={1} gap={0}>
        <Box w="100%" maxW="800px">
          <StaticImage
            src="../../../images/register_image.webp"
            alt="Vellis user register"
            layout="constrained"
          />
        </Box>
        <Text
          className="regular-text"
          color="#4A5568"
          fontSize="18px"
          pt={8}
          pb={5}
        >
          {description}
        </Text>
        {button && (
          <Button
            h="48px"
            color="#fff"
            fontSize="18px"
            className="medium-text"
            _hover={{ bg: "#4C9195" }}
            bg="#116266"
            borderRadius="9999px"
            w={{ base: "100%", md: "167px" }}
            rightIcon={<ArrowRightLine />}
          >
            {button}
          </Button>
        )}
      </VStack>
    </Stack>
  );
};

export default ApplySection;
